/** Error notices: agent run failures by kind, request and upload errors. */
export default {
  authRequiredTitle: "CLI sign-in expired",
  authRequiredDescription:
    "Your CLI provider rejected the request. Re-login in your CLI (or set the API key in Settings → Agent Runner).",
  rateLimitTitle: "Provider rate limit",
  rateLimitDescription:
    "The CLI provider is rate-limited or overloaded. Try again in a moment.",
  paymentRequiredTitle: "Payment method required",
  paymentRequiredDescription:
    "Add a payment method to your CLI provider account.",
  modelInvalidTitle: "Model not available",
  modelInvalidDescription:
    "The selected model was not found. Check the agent’s model setting.",
  providerMissingTitle: "Provider not configured",
  providerMissingDescription:
    "The CLI provider for this agent is not set up. Configure it in Settings → Agent Runner.",
  planTierTitle: "Plan upgrade required",
  planTierDescription: "This model requires a paid plan with your provider.",
  timeoutTitle: "Request timed out",
  timeoutDescription: "The AI provider timed out. Try again in a moment.",
  overloadedTitle: "API rate limit",
  overloadedDescription:
    "The AI provider is temporarily overloaded. This is not a Denker issue — try again in a moment.",
  identityCollisionTitle: "A chat couldn’t restart",
  identityCollisionCause: "Another copy was still running",
  turnCancelledBy: "A {tool} turn was cancelled",
  turnCancelled: "A turn was cancelled",
  wentWrongIn: "Something went wrong in {where}",
  wentWrong: "Something went wrong",

  planLimitReached: "Plan limit reached",
  permissionDenied: "Permission denied",
  tooManyRequests: "Too many requests",
  waitAndRetry: "Please wait a moment and try again.",
  requestFailed: "Request failed",
  serverWentWrong: "Something went wrong on the server",
  retryInMoment: "Please try again in a moment.",
  networkError: "Network error",
  couldNotReach: "Couldn't reach {host}. Check your connection and try again.",
  checkConnection: "Check your internet connection and try again.",
  unexpectedError: "An unexpected error occurred",

  uploadFailed: "Upload failed",
  uploadFailedStatus: "Upload failed ({status})",
  uploadFailedConnection: "Upload failed. Check your connection and try again.",
  uploadCancelled: "Upload cancelled.",
  fileReadFailed: "File read failed",
} as const;
